import { api, download } from "../helpers";

const prefix = "/players";

export const getList = (payload, token) =>
	api(`${prefix}`, "GET", undefined, payload, token);

export const updateTitle = ({ id, title }, token) => {
	switch (title) {
		case "ELITE4":
		case "NEW_TRAINER":
			return api(
				`${prefix}/${id}/general-title`,
				"PUT",
				{ title },
				undefined,
				token
			);

		default:
			return api(
				`${prefix}/${id}/marketplace-title`,
				"PUT",
				{ title },
				undefined,
				token
			);
	}
};

export const exportPlayers = (params, token) =>
	download(`${prefix}/export`, params, token);

export const getPlayerDetail = (param, token) => {
	const { player, ...etc } = param;

	return api(`${prefix}/${player}/detail`, "GET", undefined, etc, token);
};

export const getTournaments = (param, token) => {
	return api(`${prefix}/tournaments`, "GET", undefined, param, token);
};

export const updateSuspend = (payload, token) => {
	const { id, ...rest } = payload;

	return api(`${prefix}/${id}/suspend`, "PUT", rest, undefined, token);
};
